import {AppState} from "@redux";
import _ from 'lodash';
import {setFormData} from "../@redux/formData/actions";
import {_isBlank, toBool, toOptions, toString, wrapArray} from "../components/utils";
import {FIELD_TYPES} from "../data";
import {getAPIVersion} from "../helpers/getAirtableMetaAPIVersion";
import DateTime from "../components/AirtableFields/DateTime";
import {DateTime as DateTimeLuxon} from 'luxon';


export class Actions{
    ready:boolean

    form:string

    store:AppState

    init: any

    prev:any

    next:any

    changed:boolean

    dispatch:any

    _tmpFieldState:any = {}


    ft = FIELD_TYPES(getAPIVersion());



    constructor( formId:string,_store:AppState, _dispatch ) {
        this.ready = false
        this.form = formId
        this.store = _store
        this.dispatch = _dispatch
    }

    isReady = () => this.ready || (this.ready = !_isBlank(_.get(this.store.formPage.data, `${this.form}.details`)) )

    hasActions = () => this.getFormActions().length > 0

    getFormActions = () => _.get(this.store.formPage.data,`${this.form}.details.actions`) || []

    getFormFields = () => _.get(this.store.formPage.data,`${this.form}.details.fields`) || []

    getFieldConfig = (fieldId:string|any) => {
        return this.getFormFields().find(
            f => f.id === (_.isObject(fieldId as any) ? fieldId.id : fieldId) || f.name === (_.isObject(fieldId as any) ? fieldId.name : fieldId)
        )
    }

    getFormData = (state = 'next')  => state === 'init' ? this.init : (state === 'prev' ? this.prev : this.next )


    getFieldValue = (idOrName, state = 'next') => {
        if(!idOrName)return null
        const field = this.getFieldConfig(idOrName)
        if(!field)return null
        const formData = this.getFormData(state)
        return _.get(formData, field.id)
    }

    getFieldsAllState = () => _.get(this.store.formData.data,`fields.data`) || {}

    getFieldState = (fieldId:string|any) => _.has(this._tmpFieldState, fieldId) ? this._tmpFieldState[fieldId] : _.get(this.store.formData.data,`${_.isObject(fieldId as any) ? fieldId.id : fieldId}.data`) || {}

    setTempFieldState = (fieldId:string|any, data:any) => this._tmpFieldState[fieldId] = data

    dispatchFieldState = () => {
        console.log('[ACTIONS] displayFields State', this._tmpFieldState)
        const ids = Object.keys(this._tmpFieldState)
        for(let id of ids){
            this.updateFieldState(id,this._tmpFieldState[id], true)
        }
    }

    updateFieldsAllState = (state:any) => this.dispatch( setFormData( 'fields', '','',true, _.defaults( _.cloneDeep(state), this.getFieldsAllState())) )

    updateFieldState = (fieldId:string|any,state:any, dispatch = false) => {
        if(_.isObject(fieldId as any))fieldId = fieldId.id
        const existingState = this.getFieldState(fieldId)
        const newState = _.defaults( _.cloneDeep(state), existingState)
        console.log('[ACTIONS] updateFieldState', {fieldId, existingState, state: JSON.stringify(state), newState: JSON.stringify(state)})
        if(dispatch){
            this.dispatch( setFormData( fieldId, '','',true, _.cloneDeep(newState)) )
        }else{
            this.setTempFieldState(fieldId, newState)
        }

    }

    updateFieldValue = (key,val, onlyIfEmpty = false) => {
        const field = this.getFieldConfig(key)
        if(field){
            const currVal = _.get(this.next, field.id)
            console.log(`[ACTIONS] updateFieldValue`, {field: field.id, currVal, key, val, onlyIfEmpty})
            if(!onlyIfEmpty || _isBlank(currVal)) {
                switch (field.type) {
                    case this.ft.FT_SINGLE_SELECT:
                    case this.ft.FT_SINGLE_COLLAB:
                        val = _.isPlainObject(val as any) ? val.name : val
                        break;
                    case this.ft.FT_MULTI_SELECTS:
                    case this.ft.FT_MULTI_COLLABS:
                        val = wrapArray(val).map(v => _.isPlainObject(v as any) ? v.name : v)
                        break;
                }
                this.next = {...this.next, [field.id]: val}
                this.changed = true
            }
        }
    }

    updateDisplayField = (fieldId, mode, options) => {
        this.updateFieldState(fieldId, _.defaults({display: {...(options?.display || {}), mode}}, options))
    }

    doTasks = ( tasks:any|any[] ) => {
        tasks = wrapArray(tasks)
        for(let task of tasks){
            this.doTask(task)
        }
        //now flush all field state updates
        this.dispatchFieldState()
    }

    doTask = ( task:any ) => {
        let {type, field, fields, options = {}, source = {type:'field', value: '', if_empty:false}, source_state = 'next', field_state = 'next' } = task
        const doFields = wrapArray( fields || field )
        // const srcFieldInfo = this.getFieldConfig( source )
        const srcType = source?.type || 'field'
        const srcField = this.getFieldConfig(source?.value)
        const srcValue = srcType === 'field' ? this.getFieldValue( source?.value,source_state ) : source?.value
        const srcEmpty = source?.if_empty
        const srcAppend = source?.append

        for(let doField of doFields){
            const fieldInfo = this.getFieldConfig(doField)
            const fieldType = fieldInfo?.type
            const fieldValue = this.getFieldValue( fieldInfo, field_state )
            let canAppend = [this.ft.FT_RECORD_LINKS, this.ft.FT_ATTACHMENTS, this.ft.FT_MULTI_SELECTS, this.ft.FT_MULTI_COLLABS].includes(fieldType)
            console.log('[ACTIONS] FieldINFO::::', {type, fieldInfo, doField, srcValue, source, source_state, field_state, fieldValue, task} );
            switch(type){
                case 'set_template':
                    switch (fieldType) {
                        case (this.ft.CUSTOM_FORMULA):
                            this.updateFieldState(fieldInfo, {formula: srcValue})
                            break;
                        case (this.ft.CUSTOM_TEXT):
                            this.updateFieldState(fieldInfo, {template: {...(fieldInfo?.template || {}), content: srcValue}});
                            break;
                        case (this.ft.CUSTOM_DIVIDER):
                            this.updateFieldState(fieldInfo, {title: srcValue});
                            break;
                        case (this.ft.CUSTOM_SPACER):
                            this.updateFieldState(fieldInfo, {title: srcValue});
                            break;
                        default:
                         break;
                    }
                    break;
                case 'require_field':
                case 'required_field':
                    this.updateFieldState( fieldInfo, {display_status:'require'})
                    break;
                case 'optional_field':
                    this.updateFieldState( fieldInfo, {display_status:'optional'})
                    break;
                case 'disable_field':
                case 'disabled_field':
                    this.updateFieldState( fieldInfo, {display_status:'disable'})
                    break;
                case 'active_field':
                case 'activated_field':
                    this.updateFieldState( fieldInfo, {display_status:'optional'})
                    break;
                case 'set_value': {
                    let useValue = srcValue
                    let useEmpty = srcEmpty
                    let doAppend = canAppend && srcAppend
                    switch (srcValue) {
                        case '__now__':
                            useValue = Date.now()
                            break;
                        case '__true__':
                            useEmpty = false
                            useValue = true
                            break;
                        case '__false__':
                            useEmpty = false
                            useValue = false
                            break;
                        case '__toggle__':
                            useEmpty = false
                            useValue = !fieldValue
                            break;
                    }
                    if (canAppend) {
                        useValue = wrapArray(useValue)
                        if (fieldType === this.ft.FT_RECORD_LINKS) {

                        } else if (fieldType === this.ft.FT_ATTACHMENTS) {
                            useValue = useValue.map(v => _.isPlainObject(v) ? v : {url: v})
                        }
                        if (doAppend) useValue = wrapArray(fieldValue).concat(useValue)
                    }
                    console.log("[ACTIONS] SETTING VALUE", {fieldInfo, useValue,srcValue, useEmpty, canAppend, doAppend})
                    this.updateFieldValue(fieldInfo, useValue, useEmpty)
                }
                    break;
                case 'set_options': {
                    let useValue = toOptions(srcValue)
                    let fieldOptions = _.get(fieldInfo, 'options') || {}
                    if (srcAppend){
                        const fieldChoices = _.get(fieldOptions, 'choices') || []
                        useValue = wrapArray(fieldChoices).concat(useValue)
                    }
                    const newState = {options:  { ...(fieldInfo?.options || {}), choices: _.uniqBy(useValue, 'name')}}
                    console.log("[ACTIONS] Setting Options", {srcValue, useValue, srcAppend, newState, fieldOptions, fieldValue, fieldInfo})
                    this.updateFieldState(fieldInfo, newState)
                }
                    break;
                case 'set_value_key':
                    this.updateFieldValue( fieldInfo, _.get(options,srcValue) )
                    break;
                case 'clear_value':
                    this.updateFieldValue( fieldInfo, canAppend ? [] : null )
                    break;
                case 'hide_field':
                    this.updateDisplayField(fieldInfo, 'hide',options)
                    break;
                case 'show_field':
                    this.updateDisplayField(fieldInfo, fieldInfo?.display?.mode || 'edit',options)
                    break;
                case 'display_field':
                    this.updateDisplayField(fieldInfo, 'display',options)
                    break;
                case 'edit_field':
                    this.updateDisplayField(fieldInfo, 'edit',options)
                    break;
                case 'config_field':
                    this.updateFieldState( fieldInfo, {...options})
                    break;
            }
        }

    }

    start = (init, prev, next) => {
        this.init = init
        this.prev = prev
        this.next = next
        this.changed = false
    }

    processActions = (init: any, prev:any, next:any, firstTimeLoading:boolean, form_record_id: string) => {
        this.start(init, prev,next)

        const _fields = this.getFormFields()
        const fields = []
        const unProcessedFields = {}
        _.each(this.prev, (val,id) => unProcessedFields[id] = true)


        _.each( this.next, (val,id) => {
            delete unProcessedFields[id]
            if( val !== _.get(this.prev,id) ){
                const field = _fields.find( f => f.id === id )
                if(field)fields.push(field)
            }
        })
        _.each(Object.keys(unProcessedFields), id => {
            const field = _fields.find( f => f.id === id )
            if(field)fields.push(field)
        })
        const actions = this.getFormActions()
        console.log("[ACTIONS] processActions",firstTimeLoading,actions,fields,this.prev,this.next)

        if(fields.length || firstTimeLoading) {
            for (let action of actions) {

                const {status = true,triggers = [], tasks = [], conditions = {mode: 'and', items: []}} = action
                const canRun = status && (form_record_id?.startsWith('rec') ? action.runOnUpdate : action.runOnCreate)
                const canLoad = firstTimeLoading ? action.runOnFirstLoad : true
                let isTriggered = canRun && canLoad && (firstTimeLoading || this.isTriggeredAction(triggers, fields));
                console.log("[ACTIONS] Processing", {form: this.form, name: action.name, firstTimeLoading, form_record_id,status, canRun, canLoad, isTriggered, action, fields, formFields: this.getFormFields()});
                if (isTriggered) {
                    const isMet = this.processConditions(conditions)
                    const getTasks = (condition) => tasks.filter( task => task.status !== 'inactive' && task.condition === condition )
                    const met = getTasks('met')
                    const unmet = getTasks('unmet')
                    console.log('[ACTIONS] Processing Field Actions', action.name, isMet, met, unmet, conditions)
                    this.doTasks(isMet ? met : unmet)
                } else {
                    console.log('[ACTIONS] Action Not Triggered', {name: action.name, triggers, fields, formFields: this.getFormFields()})
                }

            }
        }else{
            console.log('[ACTIONS] No Fields Updated', firstTimeLoading, this.next, this.prev)
        }
        return [this.next,this.changed]
    }

    isTriggeredAction = ( triggers, updates ) => {
        triggers = wrapArray( triggers || '*' )
        updates = wrapArray(updates)
        for(let update of updates){
            const config = this.getFieldConfig(update)
            for(let trigger of triggers){
                if(trigger === '*' || trigger === config?.id || trigger === config?.name){
                    return true
                }
            }

        }
        return false
    }

    processConditions = ( conditions  ) => {

        const {mode = 'and', items = []} = conditions

        for(let item of items){
            let itemMet = this.processConditionItem(item)
            if( (itemMet && mode === 'or') || (!itemMet && mode === 'and') ){
                return itemMet
            }
        }
        let isMet = !items.length || mode === 'and'
        return isMet
    }

    toFormat = (field, val) => {
        switch(field?.type){
            case this.ft.FT_NUMBER:
            case this.ft.FT_PERCENT:
            case this.ft.FT_CURRENCY:
                return 'number'
            case this.ft.FT_DATETIME:
            case this.ft.FT_DATE:
            case this.ft.FT_LAST_MODIFIED:
            case this.ft.FT_CREATED:
                return 'date'
            default: {
                const linkedType = _.get(field, 'options.result.type', _.get(field, 'options.lookupFieldType'))
                if (linkedType) {
                    return this.toFormat({type: linkedType}, val)
                }
            }
        }
        if(_.isNumber(val))return 'number'
        if(_.isDate(val))return 'date'
        return 'string'
    }

    processConditionItem = ( item ) => {
        const {type, source, operation, comp, source_state = 'next', comp_state = 'next', format:rawFormat = '', case:case_sensitive = false} = item
        if(type === 'group')return this.processConditions( item )
        const srcField = this.getFieldConfig( source )
        const prepVal = val => Array.isArray(val) ? val.map( v => prepVal(v)) : (_.isPlainObject(val as any) ? val.url || val.name || val.id || val.label : val)
        const srcVal = prepVal(this.getFieldValue( srcField, source_state ))
        const format = rawFormat || this.toFormat( srcField, srcVal )

        const toVal = val => {
            switch(val){
                case 'NOW':
                case 'NOW()':
                    return new Date().toISOString()
                case 'TODAY()':
                    return new Date().toLocaleDateString()
                case 'TIME()':
                    return new Date().toLocaleTimeString()
            }
            return prepVal(val)
        }
        const compVal = (!comp.type || comp.type === 'field') ? this.getFieldValue( comp.value, comp_state ) : toVal(comp.value)
        console.log("[ACTIONS] Item received:::", {source, format, srcField, source_state, srcVal, compVal, comp_state, comp, item, fields: this.getFormFields()})
        const to = (val, isComp = false) => {
            switch(format) {
                case 'num':
                case 'number':
                    return Number(toString(val))
                case 'date':
                case 'datetime':
                    //console.log('TOTOTO', format, val, isComp, comp)
                    if (isComp && comp?.type === 'relative_date' && comp.unit?.id) {
                        return DateTimeLuxon.now().plus({[comp.unit?.id]:val})
                    } else {
                        return new Date(toString(val))
                    }
                default:
                    return toString(val)
            }
        }
        const toCase = (val) => case_sensitive ? (_.isArray(val) ? val.map( v=>`${v}`.toLowerCase() ) : `${val}`.toLowerCase() ) : val
        let isMet = true
        switch(type){
            case 'is_not_empty':
            case 'is_set':
                return !_isBlank(srcVal)
            case 'is_empty':
                return _isBlank(srcVal)
            case 'is_true':
                return toBool(srcVal,false)
            case 'is_false':
                return !toBool(srcVal,true)
            case 'starts_with':
                return toCase(toString(srcVal)).startsWith( toCase(toString(compVal)) )
            case 'not_starts_with':
                return !toCase(toString(srcVal)).startsWith( toCase(toString(compVal)) )
            case 'ends_with':
                return toCase(toString(srcVal)).endsWith( toCase(toString(compVal)) )
            case 'not_ends_with':
                return !toCase(toString(srcVal)).endsWith( toCase(toString(compVal)) )
            case 'contains':
                return toCase(srcVal || '').includes( toCase(toString(compVal)) )
            case 'not_contains':
                return !toCase(srcVal || '').includes( toCase(toString(compVal)) )
            case 'has_any':
                return !!wrapArray(srcVal,true).find( v => toCase(wrapArray(compVal,true)).includes(toCase(v)) )
            case 'has_none':
                return !wrapArray(srcVal,true).find( v => toCase(wrapArray(compVal,true)).includes(toCase(v)) )
            case 'has_all':
                return !wrapArray(compVal,true).find( v => !toCase(wrapArray(srcVal,true)).includes(toCase(v)) )
            case 'is_exactly':
                return wrapArray(srcVal,true).length === toCase(wrapArray(compVal,true)).length
                    && !wrapArray(srcVal,true).find( v => !toCase(wrapArray(compVal,true)).includes(toCase(v)) )
            case 'eval':
            case 'eval_length':
                switch(operation?.id || '='){
                    case '=':
                        return to(srcVal) == to(compVal,true)
                    case '>':
                        return to(srcVal) > to(compVal,true)
                    case '>=':
                        return to(srcVal) >= to(compVal,true)
                    case '<':
                        return to(srcVal) < to(compVal,true)
                    case '<=':
                        return to(srcVal) <= to(compVal,true)
                    case '!=':
                        return to(srcVal) != to(compVal,true)
                }

        }
        return isMet
    }

}
export default Actions
